import React from "react";
import FactsComponent from "./Component";
import useStores from "../../../../../../utils/useStores";
import { observer } from "mobx-react";

import './style.css';
import { QuizObject, QuizObjectFact } from "../../../../../../store/modquiz/quiz_objects/quiz-object";

type FactsContainerProps = {
    quiz_object: QuizObject;
    focusField: Function;
    blurField: (event: React.FocusEvent<HTMLInputElement>) => void;
};


const FactsContainer = observer(({ quiz_object, focusField, blurField }: FactsContainerProps) => {
    const rootStore = useStores();

    let addFact = (evt: any) => {
        rootStore.objectStore.addFact(quiz_object._id);
    }

    let setFacts = (facts: any) => {
        rootStore.objectStore.setFacts(quiz_object._id, facts);
    };
    
    let updateFact = (factID: string, factOrder: number, toSet: string, value: string) => {
        rootStore.objectStore.updateFact(quiz_object._id, factID, factOrder, toSet, value);
    };

    let quiz_objects = rootStore.objectStore.quiz_objects;
    let facts = quiz_objects.get(quiz_object._id).facts;
    
    let deleteFact = (fact: QuizObjectFact) => {
        quiz_object.removeFact(fact);
    }

    let undeleteFact = (fact: QuizObjectFact) => {
        quiz_object.restoreFact(fact);
    }

    if (facts.length == 0) {
        return (<div></div>)
        
    }

    return (
        <FactsComponent
            updateFact={updateFact}
            deleteFact={deleteFact}
            undeleteFact={undeleteFact}
            addFact={addFact}
            setFacts={setFacts}
            facts={rootStore.objectStore.quiz_objects.get(quiz_object._id).facts}
            blurField={blurField}
            focusField={focusField}
        />
    );
});

export default FactsContainer;
